import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "../shared/popup/popup.component";
import * as i2 from "../modules/language/language.service";
var LoaderService = /** @class */ (function () {
    function LoaderService(popupComponent, languageService) {
        this.popupComponent = popupComponent;
        this.languageService = languageService;
        this.visible = new BehaviorSubject(false);
    }
    LoaderService.prototype.show = function () {
        this.visible.next(true);
        document.body.classList.add('is-hidden');
    };
    LoaderService.prototype.hide = function () {
        this.visible.next(false);
        document.body.classList.remove('is-hidden');
    };
    LoaderService.prototype.hideAndShowTryAgain = function () {
        this.hide();
        var errorMessage = this.languageService.getString('messagesData', 'tryAgain');
        this.popupComponent.showPopupError({ text: errorMessage });
    };
    LoaderService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LoaderService_Factory() { return new LoaderService(i0.ɵɵinject(i1.PopupComponent), i0.ɵɵinject(i2.LanguageService)); }, token: LoaderService, providedIn: "root" });
    return LoaderService;
}());
export { LoaderService };
